import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function LineChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M3 19.3077C8.11114 12.2308 10.5 5.50001 18.3334 19.3077C23.4445 26.3847 28 23 33.6668 19.3077"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M3.37517 29.8765C6.52935 28.6787 6.93889 24.7369 12.2639 25.4627C14.0696 25.7088 15.4541 27.0788 16.9133 28.1706C21.0256 31.2475 27.9317 30.26 33.1395 26.1236"
        stroke="#CCBFFF"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
